import PropTypes from 'prop-types';
import React from 'react';
import { FDPrimaryActionIconButton } from '@facet-wealth/design';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { noop } from 'Helpers/PropTypes';
import fr from 'facet-rest';

const RefreshButton = ({
  showRefresh,
  setShowRefresh,
  resourceToRefresh,
  setRefreshedResource,
}) => {
  const { displayErrorMessage } = useSnackbarContext();
  const [refreshing, setRefreshing] = React.useState(false);

  const onRefresh = async () => {
    setRefreshing(true);
    try {
      const [refreshedResource] = await resourceToRefresh.link('self').get();
      setRefreshedResource(refreshedResource);
      setShowRefresh(false);
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to refresh');
      }
    } finally {
      setRefreshing(false);
    }
  };

  if (!showRefresh) {
    return false;
  }


  return (<FDPrimaryActionIconButton
    icon={'refresh'}
    onClick={onRefresh}
    loading={refreshing}
  />);
};

RefreshButton.defaultProps = {
  showRefresh: false,
  setShowRefresh: noop,
};

RefreshButton.propTypes = {
  showRefresh: PropTypes.bool,
  setShowRefresh: PropTypes.func,
  setRefreshedResource: PropTypes.func.isRequired,
  resourceToRefresh: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default RefreshButton;
